import React, { useState, useEffect, useRef, createRef } from "react";

//Styles
import "./Accordion.scss";

function Accordion({ elementsList }) {
  const [currentOpened, setCurrentOpened] = useState(null);
  const [heights, setHeights] = useState(elementsList.map(() => 0));
  const refs = useRef(elementsList.map(() => createRef()));

  useEffect(() => {
    let heights = elementsList.map((el, index) => refs.current[index].current.clientHeight);
    setHeights(heights);
    setCurrentOpened("");
  }, [elementsList]);

  return (
    <section className="accordion">
      {elementsList.map(({ header, content }, index) => (
        <React.Fragment key={index}>
          <button
            className={"header" + (currentOpened === index ? " shown" : "")}
            onClick={() => {
              setCurrentOpened(currentOpened === index ? "" : index);
            }}
          >
            {header}
          </button>
          <div
            style={heights[index] ? { "--content-height": heights[index] + "px" } : null}
            ref={refs.current[index]}
            className={"content" + (currentOpened === index || currentOpened === null ? " shown" : "")}
          >
            {content}
          </div>
        </React.Fragment>
      ))}
    </section>
  );
}

export default Accordion;
